import React from 'react';
import wb0 from '../img/Detail/NewYear-Detail.jpg';
import './Detail.css';
const NewYearDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default NewYearDetail;